import { render, staticRenderFns } from "./step-3-data.vue?vue&type=template&id=5341354a&"
import script from "./step-3-data.vue?vue&type=script&lang=js&"
export * from "./step-3-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports